<template>

    <!--Feature Four Start-->
    <section class="feature-four">
              <div class="feature-four-shape"></div>
              <div class="container">
                  <div class="feature-four__inner feature">
                      <div class="row justify-content-center mx-0">
                          <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-5">
                             <div class="rombo">
                                <!-- <i class="fas fa-truck-moving icono-f"></i> -->
                                <img src="assets/images/other/crane.png" class="icono-img" alt="">
                              </div>
                              <h4 class="text-rombo">Camión Pluma</h4>
                          </div>

                          <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-5">
                              <div class="rombo">
                                
                                <i class="fas fa-tools icono-f"></i>
                              </div>
                              <h4 class="text-rombo">Mantenimiento</h4>
                          </div>

                          <div class="col-12 col-sm-4 col-md-4 col-lg-4 mb-5">
                              <div class="rombo">
                                <i class="fas fa-headphones icono-f"></i>
                              </div>
                              <h4 class="text-rombo">Servicio al cliente 24/7</h4>
                          </div>

                      </div>
                      <!-- <div class="feature-four__search-box">
                          <form class="feature-four__form">
                              <div class="feature-four__form-input">
                                  <input type="search" placeholder="Search here anything...">
                                  <button type="submit"><i class="icon-magnifying-glass"></i></button>
                              </div>
                          </form>
                      </div> -->
                  </div>
              </div>
          </section>
          <!--Feature Four End-->
    
  </template>
  
  <style>
  
  .feature{
    background-color: #a8cf36 !important;
  }
  
  .feature-four{
      padding: 108px 0 60px;
  }
  .rombo {
    width:  100px; 
    height: 100px; 
    border: 3px solid #ffffff; 
    /* background: #428bca; */
    border-radius: 15%;
    transform: rotate(45deg);
    text-align: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    color: white;
    display: flex;
    justify-content: center;
  }
  
  .rombo i,.rombo img{
    transform: rotate(-45deg);
  }
  .icono-f{
    font-size: 40px; 
  }
  .icono-img{
    width: 67px;
    height: auto;
  }
  .text-rombo{
    color: #ffffff;
    margin-top: 30px;
  }
  
      @media (min-width: 576px) and (max-width: 767px) {
          .container{
              max-width: 100%!important;
          }
      }
  </style>
  
  <script>
  </script>